import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import CustomDropdown from "../../CustomControls/dropdownnnn";
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../Global/Endpoints';
import ErrorModal from "../Security/ErrorModal";
import { renderAsync } from 'docx-preview';
import mammoth from 'mammoth';
import { PDFDocument } from 'pdf-lib'; 
import { currency } from "../../Common/MasterData";
import DatePicker from "react-datepicker";
import { useLocation, useNavigate } from "react-router-dom";
import UTIF from "utif";
import  loadImage  from "image-promise";
import { ToastContainer, toast } from 'react-toastify';
import { set } from "date-fns";
import { Trans } from "react-i18next";
const WINPayReaimbursement = () =>
{
    const userInfo = useSelector((state) => state.userData);
    const token = localStorage.getItem('AccessToken');
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [serviceTypes, setServiceTypes] = useState([]);
    const [selectedServiceType, setSelectedServiceType] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [uploadedFile, setUploadedFile] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [documentType, setDocumentType] = useState("Fertility Cycle Reimbursement Receipts");
    const [physicianName, setPhysicianName] = useState("");
    const [physicianTel, setPhysicianTel] = useState("");
    const [formErrors, setFormErrors] = useState({});
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [selectedDate, setSelectedDate] = useState(null);
    const [isAddRow, setIsAddRow] = useState(false);
    const [tableRows, setTableRows] = useState([{ date: "", description: "", currency: "", amount: "",isEditable: true, isCurrencyDisabled: false, }]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [rowToDelete, setRowToDelete] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isFileError, setIsFileError] = useState(false);
    const fileInputRef = useRef(null);
    const [fileToDeleteIndex, setFileToDeleteIndex] = useState(null);
    const[isAmountMax, setIsAmountMax]=useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reproductiveType, setReproductiveType] = useState("");
    const [providerOptions, setProviderOptions] = useState([]);
    const [filteredProviderOptions, setFilteredProviderOptions] = useState([]);
    const [showProviderDropdown, setShowProviderDropdown] = useState(false);
    const isAgency = ["Surrogacy", "Adoption","Donor Egg", "Donor Sperm"].includes(selectedServiceType);
    const isProvider = ["Elective Cryopreservation"].includes(selectedServiceType);
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const companyName = localStorage.getItem("employer");

    useEffect(() => {
        // Fetch data from the API
        const fetchServiceTypes = async () => {
            setLoading(true);
            try {
                const params = {
                            MemberID: userInfo.userData.MemberID,
                            Contract: userInfo.userData.ContractIdentified,
                            ContractCode: 0,
                            URL: null,
                            Room: null,
                            Name: null,
                            EmailID: userInfo.userData.EmailID,
                            DeviceType:"PatientPortal",
                        };
                const response = await axios.post(
                    Endpoints.LoadServiceType,
                    
                        { _Params: JSON.stringify(params) ,
                         _DeviceType: "PatientPortal",
                    },
                    {
                        headers: {
                          "Content-Type": "application/x-www-form-urlencoded",
                          "Accept": "*/*",
                          Authorization: `Bearer ${token}`,
                        },
                      }
                );
                 // Check if the response has valid data
                 if (response.data && Array.isArray(response.data)) {
                    setServiceTypes(response.data);
                } else {
                    console.log("Unexpected response format:", response.data);
                    console.log("No valid service types found.");
                }
            } catch (error) {
                console.error("Error fetching service types:", error);
            } finally { 
                setLoading(false); 
            }
        };

        fetchServiceTypes();
    }, []);
    const handleServiceTypeChange = (option) => {
        setSelectedServiceType(option);
        setFormErrors((prevErrors) => ({ ...prevErrors, serviceType: "" }));
        if (option === "Elective Cryopreservation") {
            setReproductiveType("Egg");
        } else if (["Donor Egg", "Donor Sperm"].includes(option)) {
            setReproductiveType("Frozen");
        } else {
            setReproductiveType("");
        }
        setPhysicianName("");
        if (isFormSubmitted) {
            if (!physicianName) formErrors.physicianName = isAgency ? t("Agencynamevalid") : isProvider ? t("Providernamevalid") : t("Physiciannamevalid");
            if (!physicianTel) formErrors.physicianTel = isAgency ? t("Agencytelvalid") : isProvider ? t("Providertelvalid") : t("Physiciantelvalid");
        }
        // Call ReimbursementProviderDetails on service type change if isAgency or isProvider
        if (["Surrogacy", "Adoption","Donor Egg", "Donor Sperm","Elective Cryopreservation"].includes(option)) {
            ReimbursementProviderDetails("", option);
        }
    };

    // Update ReimbursementProviderDetails to handle autocomplete
    const ReimbursementProviderDetails = async (name = "", serviceType = "") => {
        const params = {
            EmailID: userInfo.userData.EmailID,
            DeviceType: "PatientPortal",
            GroupName: name ? name : "",
            ServiceType: serviceType || ""
        };
        try {
            const response = await axios.post(
                Endpoints.ReimbursementProviderDetails,
                {
                    _Params: JSON.stringify(params),
                    _DeviceType: "PatientPortal",
                },
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data && response.data.ProviderDetailsList) {
                setProviderOptions(response.data.ProviderDetailsList);
                // Filter options to match input
                setFilteredProviderOptions(
                    response.data.ProviderDetailsList.filter(opt =>
                        opt.GroupName.toLowerCase().includes((name || '').toLowerCase())
                    )
                );
            } else {
                setProviderOptions([]);
                setFilteredProviderOptions([]);
            }

        } catch (error) {
            setProviderOptions([]);
            setFilteredProviderOptions([]);
            console.error("No data received from the reimbursement provider.", error);
        }
    };

    const handleFileSelection = (event) => {
        const validExtensions = ["pdf", "tiff", "jpeg", "jpg", "bmp", "png"];
        const files = Array.from(event.target.files);
        let anyInvalidType = false;
        let anyTooLarge = false;
        let duplicateFound = false;

        // Check for duplicates with already selected files
        for (const file of files) {
            const isDuplicate = selectedFiles.some(
                f => f.name === file.name && f.size === file.size
            );
            if (isDuplicate) {
                duplicateFound = true;
                break;
            }
        }

        // Check for duplicates within the new files themselves
        const fileSignatures = new Set();
        for (const file of files) {
            const signature = `${file.name}_${file.size}`;
            if (fileSignatures.has(signature)) {
                duplicateFound = true;
                break;
            }
            fileSignatures.add(signature);
        }

        if (duplicateFound) {
            return toast.error("Duplicate file(s) detected. Please select unique files only.");
        }

        if((files.length + selectedFiles.length)>4) return toast.error("Maximum 4 files are allowed");
        const validFiles = files.filter(file => {
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                anyInvalidType = true;
                return false;
            }
            if (file.size > 2 * 1024 * 1024) {
                anyTooLarge = true;
                return false;
            }
            return true;
        });
        if (anyInvalidType) {
            setModalMessage("Invalid file type. Only PDF, TIFF, JPEG, BMP, or PNG allowed.");
            setIsFileError(true);
            setShowModal(true);
            return;
        } else if (anyTooLarge) {
            setModalMessage("File size should not exceed 2MB.");
            setIsFileError(true);
            setShowModal(true);
            return;
        }
        setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
        setFormErrors((prevErrors) => ({ ...prevErrors, files: "" }));
        setUploadSuccess(false);

        // Clear the file input value to allow re-uploading the same file
        if (event.target) {
            event.target.value = null;
        }
        
    };

    const handleSubmit = async () => {
        const errors = {};
    if (!selectedServiceType) errors.serviceType = t("servicetypevalid");
    if (!selectedFiles.length) errors.files = t("filevalid");
        if (!physicianName.trim()) errors.physicianName = isAgency
            ? t("Agencynamevalid") : isProvider ? t("Providernamevalid") : t("Physiciannamevalid");
        if (!physicianTel) errors.physicianTel = isAgency
            ? t("Agencytelvalid") : isProvider ? t("Providertelvalid") : t("Physiciantelvalid");
    if (!tableRows.length) errors.table = "At least one row is required.";
    if (!checkboxChecked) errors.checkbox = "You must agree to the terms.";

    // Validate each row's description for non-empty and not just spaces
  tableRows.forEach((row, idx) => {
    if (!row.description || row.description.trim() === "") {
      errors.table = "Description cannot be empty or just spaces.";
    }
  });

    const validRows = tableRows.filter(
        (row) =>
          row.date &&
          row.description.trim() !== "" &&
          row.currency &&
          row.amount
      );
    
      if (validRows.length === 0) {
        errors.table = "At least one row is required.";
      }
    
      setFormErrors(errors);
        if (!checkboxChecked) errors.checkbox = "You must agree to the terms.";
      
        setFormErrors(errors);
      

    setFormErrors(errors);
    setIsFormSubmitted(true);
    if (Object.keys(errors).length > 0) {
        return;
    }
    
        try {
            let fileID = 1; // Initialize FileID to start from 1
            const payloads = []; // Array to hold all file payloads
    
            for (const file of selectedFiles) {
                let noOfPages = 1;
    
                // Determine the number of pages based on file type
                try {
                    const fileType = file.type;
    
                    if (fileType === "application/pdf") {
                        const inputBytes = await file.arrayBuffer();
                        const pdfDoc = await PDFDocument.load(inputBytes);
                        noOfPages = pdfDoc.getPageCount();
                    } else if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                        const arrayBuffer = await file.arrayBuffer();
                        const content = await mammoth.extractRawText({ arrayBuffer });
                        const wordCount = content.value.split(/\s+/).length;
                        noOfPages = Math.ceil(wordCount / 500);
                    } else if (fileType === "text/plain") {
                        const textContent = await file.text();
                        const lineCount = textContent.split(/\r?\n/).length;
                        noOfPages = Math.ceil(lineCount / 50);
                    }else if (fileType === "image/tiff") {
                        const buffer = await file.arrayBuffer();
                        const pages = UTIF.decode(buffer); // Decode TIFF file
                        noOfPages = pages.length; // Number of pages in the TIFF file
                    }else if (
                        fileType === "image/jpeg" ||
                        fileType === "image/png" ||
                        fileType === "image/bmp"
                      ) {
                        noOfPages = 1 // Single-page image
                      }
                } catch (pageError) {
                    console.warn(`Failed to determine page count for ${file.name}:`, pageError);
                }
    
                const fileToBase64 = (file) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(",")[1]);
                        reader.onerror = (error) => reject(error);
                        reader.readAsDataURL(file);
                    });
    
                const base64Data = await fileToBase64(file);
    
                // Create payload for each file
                const filePayload = {
                    FileID: fileID.toString(), // Use the incrementing FileID
                    FilePath: "",
                    FileName: file.name,
                    NoOFPages: noOfPages.toString(),
                    DocTypeDesc: "",
                    inputBytes: base64Data,
                    fileSize: file.size.toString(),
                    memberId: userInfo.userData.MemberID,
                    contract: userInfo.userData.ContractIdentified,
                    contractCode: "",
                    docTypeDescription: documentType,
                    DeviceType:"PatientPortal",
                    EmailID:userInfo.userData.EmailID
                };
                console.log("filePayload",filePayload)
    
                payloads.push(filePayload);
                fileID++; // Increment FileID for the next file
            }
            setLoading(true);
            // Send all files in a single request
            const response = await axios.post(
                Endpoints.UploadDocument,
                JSON.stringify(payloads),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("res",response.data)
            // Handle response where each file has a FilePath in response.data array
            const filePaths = response.data.map((file) => file.FilePath);
            // Prepare SendToWin payload for all files
            const sendToWinPayload = {
                _Params: JSON.stringify({
                    MemberID: userInfo.userData.MemberID,
                    Contract: userInfo.userData.ContractIdentified,
                    DocumentTypes: "",
                    DoctypeDesc: documentType,
                    Documents: response.data.map((file, index) => ({
                        NoOFPages: payloads[index].NoOFPages,
                        FilePath: file.FilePath,
                        FileID: payloads[index].FileID,
                        FileName: payloads[index].FileName,
                        DocTypeDesc: "",
                    })),
                    ReimbursementDetails: tableRows.map((row) => ({
                        DateIncurred: row.date.toLocaleDateString("en-US"),
                        ServiceName: row.description,
                        Currency: row.currency,
                        Amount: parseFloat(parseFloat(row.amount).toFixed(2)),
                    })),
                    TotalAmount:  parseFloat(
                        tableRows.reduce((sum, row) => sum + parseFloat(row.amount|| 0),  0).toFixed(2)
                    ),
                    PhysicianName: physicianName,
                    PhysicianTelNo: physicianTel,
                    PhysicianTaxNo: null,
                    ReimbursementType: "I would like to be reimbursed for an eligible service",
                    ServiceType: selectedServiceType,
                    ReproductiveType: reproductiveType || "",
                    AuthNo: null,
                    EmailID: userInfo.userData.EmailID || null, 
                    UserName: "MAPP", 
                    ProviderID: null, 
                    GroupID: "", 
                    Speciality: null, 
                    Activity: null, 
                    DeviceType: "PatientPortal"
                }),
            };
            // Call SendToWin API
            const res = await axios.post(Endpoints.SendToWin, sendToWinPayload, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${token}`,
                },
            });
            if(res.data){
                setIsFileError(false);
                setIsAddRow(false);
                setModalMessage(res.data)
            setShowModal(true);
            setSelectedFiles([]);
            setDocumentType("");
            }else {
                // Handle API response that indicates failure
                const errorMessage = res.data || "An unexpected error occurred.";
                console.error("API Error Response:", errorMessage);
                setModalMessage(`Error: ${errorMessage}`);
                setShowModal(true);
            }
          // call ReimbursementProviderDetails  api
          if(isAgency || isProvider) {
            ReimbursementProviderDetails(physicianName, selectedServiceType);
          }
            
        } catch (error) {
            console.error("Error during document submission:", error);
            console.log("An error occurred while processing the documents.");
        }
        finally {        
             setLoading(false);    
        }
    };

    const handleViewFile = async (file) => {
        const fileType = file.type;

        if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            const fileArrayBuffer = await file.arrayBuffer();
            
            // Open a new window
            const newWindow = window.open("", "_blank");
            if (newWindow) {
                // Write basic HTML structure to new window
                newWindow.document.write(`
                    <html>
                        <head>
                            <title>Document Preview</title>
                            <style>body { font-family: Arial, sans-serif; margin: 20px; }</style>
                        </head>
                        <body>
                            <div id="docx-preview"></div>
                        </body>
                    </html>
                `);
                newWindow.document.close();

                // Render the document into the new window
                renderAsync(fileArrayBuffer, newWindow.document.getElementById("docx-preview"));
            }
        } else {
            // For other types, open directly
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
        }
    };
    const handleFileDelete = (index) => {
        setModalMessage("Are you sure you want to delete this file?");
        setFileToDeleteIndex(index); // Set the file index for deletion
        setShowDeleteModal(true);
    };

     // Add a new row
     const handleAddRow = () => {
        const lastRow = tableRows[tableRows.length - 1];
        if (!lastRow.date || !lastRow.description || !lastRow.currency || !lastRow.amount) {
          setModalMessage("Please fill all fields in the current row before adding a new row.");
          setIsAddRow(true); // Reset the flag
          setShowModal(true);
          return;
        }
       // setTableRows([...tableRows, { date: "", description: "", currency: "", amount: "" }]);

       // Mark the last row as non-editable
    const updatedRows = tableRows.map((row, index) =>
        index === tableRows.length - 1 ? { ...row, isEditable: false, isCurrencyDisabled: true } : row
      );
    
      // Add a new row with isEditable set to true
      setTableRows([
        ...updatedRows,
        { date: "", description: "", currency: isHighmarkPortal ? "United States Dollar" : lastRow.currency, amount: "", isEditable: true, isCurrencyDisabled: isHighmarkPortal?    true: true },
      ]);
      };

      const handleDeleteRow = (index) => {
        if (tableRows.length === 1) {
          setUploadedFile([]); // Clear files
          setTableRows([{ date: "", description: "", currency: isHighmarkPortal ? "United States Dollar" : "", amount: "",isEditable: true,isCurrencyDisabled: isHighmarkPortal }]);
    
          setTotalAmount(0);
          
        } else {
            const rowToDelete = tableRows[index];
  
            // Check if the row has no data
            const isRowEmpty =
              !rowToDelete.date &&
              !rowToDelete.description &&
              !rowToDelete.currency &&
              !rowToDelete.amount;
        
            if (!isRowEmpty) {
              // Remove the row if it contains data
              const updatedRows = tableRows.filter((_, i) => i !== index);
               // If only one row remains, make it editable
  if (updatedRows.length === 1) {
    updatedRows[0].isEditable = true;
    updatedRows[0].isCurrencyDisabled = isHighmarkPortal? true: false;
  }
              setTableRows(updatedRows);
              calculateTotalAmount(updatedRows);
            } else {
              // If row is empty, mark it non-editable
              const updatedRows = tableRows.map((row, i) =>
                i === index ? { ...row, isEditable: false } : row
              );
              setTableRows(updatedRows);
            }
          }
      };
    
  // Handle input change for specific field and row
  const handleInputChange = (index, field, value) => {
    const updatedRows = tableRows.map((row, i) =>{
        if (i === index && row.isEditable) {

            if (field === "currency" && row.isCurrencyDisabled) return row;

            const updatedValue = field === "amount" ? sanitizeAmountInput(value) : value;

            return { ...row, [field]: updatedValue };
          }
          return row;
        });
     // Ensure rows are updated and total amount is recalculated
     setTableRows(updatedRows);
     calculateTotalAmount(updatedRows);
  // Dynamically validate table rows
  const allRowsValid = updatedRows.every(
    (row) =>
      row.date &&
      row.description &&
      row.currency &&
      row.amount
  );

  setFormErrors((prevErrors) => ({
    ...prevErrors,
    table: allRowsValid ? "" : prevErrors.table, // Clear error if all rows are valid
  }));
  };

  const handleKeyDown = (e) => {
    // Prevent entering 'e', '-', and '+' characters
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };
// Utility for formatting numbers in US format
const formatAmountForDisplay = (value) => {
    if (!value || isNaN(value)) return "";
  const numericValue = parseFloat(value);
    return numericValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  // Utility method for sanitizing the input
const sanitizeAmountInput = (value) => {
    // Allow only numbers and one decimal point
    let sanitizedValue = value.replace(/[^0-9.]/g, "");
  
    // Prevent multiple decimal points
    if ((sanitizedValue.match(/\./g) || []).length > 1) {
      return sanitizedValue.substring(0, sanitizedValue.lastIndexOf("."));
    }
    // Prevent input from starting with a dot
    if (sanitizedValue.startsWith(".")) {
        sanitizedValue = "0."; // Automatically prefix with "0"
      }
    // Restrict to two decimal places
    if (sanitizedValue.includes(".")) {
      const [integerPart, decimalPart] = sanitizedValue.split(".");
      sanitizedValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
    }
  
    // Prevent leading zeros unless it's "0."
    if (sanitizedValue.startsWith("0") && !sanitizedValue.startsWith("0.") && sanitizedValue.startsWith(".")) {
      sanitizedValue = sanitizedValue.replace(/^0+/, "");
    }
  
    // Validate max value
    const numericValue = parseFloat(sanitizedValue);
    // if (numericValue > 99999.99) {
    //   setModalMessage(t("maxammountvalid"));
    //   setIsAmountMax(true);
    //   setShowModal(true)
    //   return "";
    // }
  
    return sanitizedValue;
  };
  useEffect(() => {
  if (isHighmarkPortal) {
    // Set all rows to USD and disable currency selection
    setTableRows((rows) =>
      rows.map((row, idx) => ({
        ...row,
        currency: "United States Dollar",
        isCurrencyDisabled: true,
      }))
    );
  }
}, [isHighmarkPortal]);

  const confirmDeleteRow = () => {
    if (fileToDeleteIndex !== null) {
        setSelectedFiles((prevFiles) =>
            prevFiles.filter((_, i) => i !== fileToDeleteIndex)
        );
        setFileToDeleteIndex(null); // Reset the file index after deletion
    }
    setShowDeleteModal(false); // Close the modal
  };

  // Calculate total amount
  const calculateTotalAmount = (rows) => {
    const total = rows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
    setTotalAmount(total);
  };

  const handleModalClose = () => {
    setShowModal(false);
    if(isFileError || isAddRow || isAmountMax)
    {
        return;
    }
        navigate("/pay-landingpage");
    
     
  };
  const handleBackClick = () => {
    navigate("/pay-landingpage");
};
const onBrowse = () => {
    const input = document.getElementById('fileInput');
    if (input) {
        input.value = null; // Always reset so change event fires even for same file
        input.click();
    }
};
if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

return(
    <>
 <ToastContainer />
{isHighmarkPortal ? 
            <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">
                {isHighmarkPortal ? "Fertility and Family Building Pay Reimbursement" : t('winPayReimbursement')}
            </h2>
            </div>:
            <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>    
                {t('Back')}        
                </span>
            </button>       
            <h2 className="page-heading">
                {isHighmarkPortal ? "Fertility and Family Building Pay Reimbursement" : t('winPayReimbursement')}
            </h2>
            </div>
          }
     {/* <div className="col-md-12 col-lg-12 mt-md-4 mt-sm-0 inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={handleBackClick}><span><i className='bi bi-chevron-left'></i> {t('back')}</span></button>
            
            <h2 className="page-heading">{t('winPayReimbursement')}</h2>
        </div> */}

        <div className="col-md-12 text-center mb-2 mb-md-5">
            <b>{t('reimbursementRequest')}</b>
        </div>


        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-auto">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                    {t('servicetype')}
                    </label>
                </div>
                      
                <div class="col-auto">
                    {/* <input type="text" className="form-control win-form-control mobile-view" value="" autoComplete="off" /> */}
                    <CustomDropdown
                            className="form-control win-form-control"
                            id="serviceType"
                            options=
                            {serviceTypes.map((option) => option.Text)}
                            selectedOption={selectedServiceType}
                            onChange={handleServiceTypeChange}
                            placeholder={t("servicetypeplacholder")}
                       />

                    <div className="form-field-error-message">
                    {formErrors.serviceType && <div className="form-field-error-message">{formErrors.serviceType}</div>}
                    </div>
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-auto ">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                     {t('uploadFilesLabel')} 
                    </label>
                </div> 

                <div class="col-auto">

                    
                <div class="custom-file-upload ms-auto">
                    <input
                        type="file"
                        multiple
                        id="fileInput"
                        class="file-input"
                        onChange={handleFileSelection}
                        ref={fileInputRef}
                        accept=".pdf, .tiff, .jpeg, .jpg, .bmp, .png"
                    />
                    <div class="input-display">
                        <input type="text" class="file-text" placeholder={t("choosefileplaceholder")} readonly />
                        <button type="button" class="custom-button"  onClick={onBrowse}>{t("browse")}</button>
                    </div>
                </div>
       

                {/* <button
                            type="button"
                            className="form-control win-form-control mobile-view"
                            onClick={() => document.getElementById("selectDocuments").click()}
                        >
                            Select documents
                        </button>
                        <input
                            type="file"
                            id="selectDocuments"
                            className="form-control win-form-control mobile-view" 
                            value="" 
                            autoComplete="off"
                            multiple
                            style={{ display: "none" }}
                            onChange={handleFileSelection}
                        /> */}
                    <div className="note-gray-boldd-14">
                    {t('validationsmsg')}
                    </div>
                    <div className="form-field-error-message">
                    {isAgency && <div>*Reimbursement Form required for claim review text</div>}
                    {formErrors.files && <div className="form-field-error-message">{formErrors.files}</div>}
                    </div>
                </div>
                     </div>
        </div>
        <div>
            {(["Donor Egg", "Donor Sperm"].includes(selectedServiceType)) && (
                ["Frozen", "Fresh"].map((type) => (
                    <span key={type}>
                        <input
                            type="radio"
                            id={`${type.toLowerCase()}Option`}
                            name="reproductiveTypeOptions"
                            value={type}
                            checked={reproductiveType === type}
                            onChange={() => setReproductiveType(type)}
                        />
                        <label style={{ marginLeft: "6px",transform: "translateY(-4px)"}} htmlFor={`${type.toLowerCase()}Option`}>{type}</label>
                    </span>
                ))
            )}
            {(selectedServiceType === "Elective Cryopreservation") && (
                ["Egg", "Sperm", "Embryo"].map((type) => (
                    <span key={type}>
                        <input
                            type="radio"
                            id={`${type.toLowerCase()}Option`}
                            name="reproductiveTypeOptions"
                            value={type}
                            checked={reproductiveType === type}
                            onChange={() => setReproductiveType(type)}
                        />
                        <label style={{ marginLeft: "6px",transform: "translateY(-4px)"}}htmlFor={`${type.toLowerCase()}Option`}>{type}</label>
                    </span>
                ))
            )}
        </div>
        <div className="mt-2 md-5">
        <div className="form-field-error-message">{t('msg')}</div>
        </div>
        <div className="mt-2 winpay-table-wrapper">
            <table className="table">
                <thead className="winpay-table-header">
                    <tr className="winpay-table-header">
                        <th width="80%">{t("filenamelable")}</th>
                        <th width="140" className="text-center">{t("btnview")}</th>
                        <th width="140" className="text-center">{t("btndelete")}</th>
                    </tr>
                </thead>
                <tbody>
                {selectedFiles.map((file, index) => (
                            <tr className="winpay-table-row" key={index}>
                                <td>{file.name}</td>
                                <td className="text-center">
                                    <button
                                        className="winpay-table-view-icon mx-auto"
                                        onClick={() => handleViewFile(file)}
                                    >
                                    </button>
                                </td>
                                <td className="text-center">
                                    <button
                                        className="winpay-table-trash-icon mx-auto"
                                        onClick={() => handleFileDelete(index)}
                                    >
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {selectedFiles.length === 0 && (
                            <tr>
                                <td colSpan="3" className="text-center">
                                {t('noFilesUploaded')}
                                </td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>

        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-auto">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                    {isAgency ? t("Agencyname"): isProvider ? t("providername") : t("Physicianname")}
                    </label>
                </div>

                <div class="col-auto">
                    {isAgency || isProvider ? (
                        <div>
                            <input
                                type="text"
                                className="form-control win-form-control mobile-view"
                                id="providerNameDropdown"
                                value={physicianName}
                                autoComplete="off"
                                maxLength="100"
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    setPhysicianName(inputValue);
                                    setFormErrors((prevErrors) => ({ ...prevErrors, physicianName: "" }));
                                    if (isAgency || isProvider) {
                                        if (providerOptions.length > 0) {
                                            setFilteredProviderOptions(
                                                providerOptions.filter(opt =>
                                                    opt.GroupName.toLowerCase().includes((inputValue || '').toLowerCase())
                                                )
                                            );
                                            setShowProviderDropdown(true);
                                        } else {
                                        }
                                    }
                                }}
                                onBlur={() => {
                                    setTimeout(() => setShowProviderDropdown(false), 150); // Delay to allow click
                                }}
                                onFocus={() => {
                                    if (filteredProviderOptions.length > 0) setShowProviderDropdown(true);
                                }}
                            />
                            {showProviderDropdown && filteredProviderOptions.length > 0 && (
                                <ul className="dropdown-list">
                                    {filteredProviderOptions.map((opt, idx) => (
                                        <li
                                            key={idx}
                                            onMouseDown={() => {
                                                setPhysicianName(opt.GroupName);
                                                setShowProviderDropdown(false);
                                                setProviderOptions([]);
                                                setFilteredProviderOptions([]);
                                            }}
                                        >
                                            {opt.GroupName} 
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : (
                        <input
                            type="text"
                            className="form-control win-form-control-g mobile-view"
                            value={physicianName}
                            onChange={(e) => {
                                setPhysicianName(e.target.value);
                                setFormErrors((prevErrors) => ({ ...prevErrors, physicianName: "" }));
                            }}
                            maxLength="100"
                            autoComplete="off"
                        />
                    )}
                    <div className="form-field-error-message">
                    {formErrors.physicianName && <div className="form-field-error-message">{formErrors.physicianName}</div>}
                    </div>
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div className="mb-3 row flex-sm-row flex-column">
                <div class="col-auto">
                    <label htmlFor="serviceType" className="form-label win-form-label mandatory mt-2">
                    {isAgency ? t("Agencytelname"): isProvider ? t("Providertelname") : t("Physiciantelname")}
                    </label>
                </div>

                <div class="col-auto">
                    <input type="text" 
                        className="form-control win-form-control-g mobile-view"
                        value={physicianTel}
                        onChange={(e) => {
                            // Only allow up to 10 digits
                            const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                            setPhysicianTel(value);
                            setFormErrors((prevErrors) => ({ ...prevErrors, physicianTel: "" }));
                        }}
                        onBlur={() => {
                            // Show error if not exactly 10 digits
                            if (physicianTel && !/^\d{10}$/.test(physicianTel)) {
                                setFormErrors((prevErrors) => ({ ...prevErrors, physicianTel: t("Please enter a valid 10-digit phone number") }));
                            }
                        }}
                        maxLength="10"
                        autoComplete="off"
                    />
                    <div className="form-field-error-message">
                        {formErrors.physicianTel && <div className="form-field-error-message">{formErrors.physicianTel}</div>}
                    </div>
                </div>
            </div>
        </div>


        <div class="mt-2 winpay-table-wrapper">

            {/* Same below table in Mobile View */}
            <div className="d-none d-md-block">
                <table className="table winpay-table">
                    <thead className="winpay-table-header">
                        <tr className="winpay-table-header">
                            <th width="200" className="ps-3">
                            {t("datetbl")}
                            </th>
                            <th className="ps-3">{t("descriptiontbl")}</th>
                            <th width="240" className="ps-3">{t("currencytbl")}</th>
                            <th width="200" className="ps-3">{t("amounttbl")}</th>
                            <th width="140" className="text-center">{t("actionstbl")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRows.map((row, index) => (
                            <tr key={index} className="winpay-table-row">
                            <td>
                                <DatePicker
                                selected={row.date ? new Date(row.date) : null}
                                onChange={(date) => handleInputChange(index, "date", date)}
                                dateFormat="MM/dd/yyyy"
                                className="custom-datepicker form-control win-form-control w-100-percent calendar-control"
                                placeholderText="MM/DD/YYYY"
                                showYearDropdown
                                scrollableYearDropdown
                                maxDate={new Date()}
                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input
                                disabled={!row.isEditable}
                                />
                            </td>
                            <td>
                                <input
                                type="text"
                                value={row.description}
                                onChange={(e) => handleInputChange(index, "description", e.target.value)}
                                className="form-control win-form-control w-100-percent"
                                disabled={!row.isEditable}
                                />
                            </td>
                            <td className="custom-dropdown-width-controll">
                                <CustomDropdown
                                options={currency.map((item) => item.name)} 
                                selectedOption={row.currency}
                                onChange={(option) => handleInputChange(index, "currency", option)}
                                searchable={true}
                                placeholder={t("currencyplaceholder")}
                                disabled={!row.isEditable || row.isCurrencyDisabled}
                                />
                            </td>
                            <td>
                                <input
                                type="text"
                                value={
                                    row.isEditable
                                    ? row.amount // Raw input during editing
                                    : formatAmountForDisplay(row.amount) // US format when not editable
                                }
                                onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="form-control win-form-control w-100-percent"
                                min={0}
                                disabled={!row.isEditable}
                                inputMode="decimal"
                                />
                            </td>
                            <td align="center">
                                <button
                                className="win-btn-secondary-winpay-gird"
                                onClick={() => handleDeleteRow(index)} // Remove the row
                                >
                                {t('removebtn')}
                                </button>
                            </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="winpay-table-row">
                            <td colSpan="3">{t('totalrequestedamount')}</td>
                            <td className="ps-4">{Number(totalAmount).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                                })}
                            </td>
                            <td align="center">
                            <button className="win-btn-primary-winpay-gird" onClick={handleAddRow}>
                            {t('addrow')}
                            </button>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        

            {/* Same above table in Mobile View */}
            <div className="d-md-none"> 
                {tableRows.map((row, index) => (
                <div className="mobile-row mb-3 p-3 border rounded" key={index}>
                    <div><strong>{t("datetbl")}:</strong>
                    <DatePicker
                        selected={row.date ? new Date(row.date) : null}
                        onChange={(date) => handleInputChange(index, "date", date)}
                        dateFormat="MM/dd/yyyy"
                        className="form-control win-form-control mobile-view"
                        placeholderText="MM/DD/YYYY"
                        showYearDropdown
                        scrollableYearDropdown
                        maxDate={new Date()}
                        onKeyDown={(e) => e.preventDefault()}
                        disabled={!row.isEditable}
                    />
                    </div>
                    <div className="mt-2"><strong>{t("descriptiontbl")}:</strong>
                    <input
                        type="text"
                        value={row.description}
                        onChange={(e) => handleInputChange(index, "description", e.target.value)}
                        className="form-control win-form-control mobile-view"
                        disabled={!row.isEditable}
                    />
                    </div>
                    <div className="mt-2"><strong>{t("currencytbl")}:</strong>
                    <CustomDropdown
                        options={currency.map((item) => item.name)} 
                        selectedOption={row.currency}
                        onChange={(option) => handleInputChange(index, "currency", option)}
                        searchable
                        placeholder={t("currencyplaceholder")}
                        disabled={!row.isEditable || row.isCurrencyDisabled}
                    />
                    </div>
                    <div className="mt-2"><strong>{t("amounttbl")}:</strong>
                    <input
                        type="text"
                        value={
                        row.isEditable
                            ? row.amount
                            : formatAmountForDisplay(row.amount)
                        }
                        onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="form-control win-form-control mobile-view"
                        min={0}
                        disabled={!row.isEditable}
                        inputMode="decimal"
                    />
                    </div>
                    <div className="mt-3 text-center">
                    <button
                        className="win-btn-secondary highmark-option-no-border mobile-view"
                        onClick={() => handleDeleteRow(index)}
                    >
                        {t('removebtn')}
                    </button>
                    </div>
                </div>
                ))}
                <div className="text-end mt-3">
                <div><strong>{t('totalrequestedamount')}:</strong> {Number(totalAmount).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}</div>
                <button className="win-btn-primary mobile-view mt-3" onClick={handleAddRow}>
                    {t('addrow')}
                </button>
                </div>
            </div>
        </div>
        
        {formErrors.table && <div className="form-field-error-message">{formErrors.table}</div>}
        <div className="col-12 d-flex mt-1 mb-5">
            <div className="me-2">
            <input
          type="checkbox"
          className="form-check-input radio-btn win-form-check-input mobile-view"
          checked={checkboxChecked}
          onChange={() => {
            setCheckboxChecked(!checkboxChecked);
            setFormErrors((prevErrors) => ({ ...prevErrors, checkbox: "" }));
          }}
         
        />
            </div>
        <div className="note-black-14 ms-3">
            {isHighmarkPortal ? (
                t("termsandconditionff")
            ) : (
                <Trans
                i18nKey="termsandcondition"
                values={{ companyName }}
                components={{ strong: <strong /> }}
                />
            )}
        </div>
        </div>
        {formErrors.checkbox && <div className="form-field-error-message">{formErrors.checkbox}</div>}
        <div className="col-12 text-center mb-4">
        <button className="win-btn-primary mobile-view" onClick={handleSubmit}>{t('senddocumentsbtn')}</button>
        </div>
        <div className="col-12 text-center mb-4">&nbsp;</div>
        <ErrorModal  show={showDeleteModal}
        message={modalMessage}
        onClose={() => setShowDeleteModal(false)}
        onOkay={confirmDeleteRow}
        isCancellationSelected={true}  />
    <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose}  />
    </>
)
}
export default WINPayReaimbursement;